import React, { Dispatch, FC, SetStateAction } from "react";

import { getDefaultExhibitionFinderFilters } from "../../utils/exhibitions";
import { Chip } from "../forms";
import { TagColors, TagDimensions } from "../forms/elements/tags/types";
import { materialsOptions } from "../forms/forms-fields/materials-form-fields";
import { MaterialsFormFieldsLabels } from "../forms/forms-fields/materials-form-fields/types";
import { EMPTY_OPTION_VALUE } from "./constants";
import { ExhibitionFinderFiltersFormTypes } from "./types";

export interface ExhibitionFiltersSummaryProps {
  appliedFilters: ExhibitionFinderFiltersFormTypes;
  setAppliedFilters: Dispatch<SetStateAction<ExhibitionFinderFiltersFormTypes>>;
  labels: MaterialsFormFieldsLabels & {
    "exhibition-finder-panel-clear-filters": string;
    "exhibition-finder-panel-location": string;
  };
}

export const ExhibitionFiltersSummary: FC<ExhibitionFiltersSummaryProps> = ({
  labels,
  appliedFilters,
  setAppliedFilters,
}) => {
  const { materials, location, search } = appliedFilters;

  return (
    <div className="flex items-start justify-between gap-2">
      <div className="flex items-center gap-2 flex-wrap">
        {materialsOptions
          .filter((key) => materials[key])
          .map((key) => (
            <Chip
              checked
              dimension={TagDimensions.Medium}
              onChange={() => {
                setAppliedFilters((filters) => ({
                  ...filters,
                  materials: {
                    ...filters.materials,
                    [key]: false,
                  },
                }));
              }}
              key={key}
              color={TagColors.Neutral}
            >
              {labels?.[key as keyof MaterialsFormFieldsLabels]}
            </Chip>
          ))}
        {location && (
          <Chip
            checked
            dimension={TagDimensions.Medium}
            onChange={() => {
              setAppliedFilters((filters) => ({
                ...filters,
                location: EMPTY_OPTION_VALUE,
              }));
            }}
            color={TagColors.Neutral}
          >
            {location}
          </Chip>
        )}
        {search && (
          <Chip
            checked
            dimension={TagDimensions.Medium}
            onChange={() => {
              setAppliedFilters((filters) => ({
                ...filters,
                search: EMPTY_OPTION_VALUE,
              }));
            }}
            color={TagColors.Neutral}
            className="max-w-[16ch] truncate"
          >
            {search}
          </Chip>
        )}
      </div>
      <button
        className="font-bold text-primary hover:underline p-2 flex-none"
        type="submit"
        onClick={() => {
          setAppliedFilters((filters) => ({
            ...getDefaultExhibitionFinderFilters(),
            time: filters.time, // preserve time
          }));
        }}
      >
        {labels["exhibition-finder-panel-clear-filters"]}
      </button>
    </div>
  );
};
